import { render, staticRenderFns } from "./DashboardDialogButtons.vue?vue&type=template&id=b1dd4c60&"
import script from "./DashboardDialogButtons.vue?vue&type=script&lang=js&"
export * from "./DashboardDialogButtons.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDialogButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports